import React, { useEffect, useState } from "react";
import { Button, Col, Dropdown, Row, Tag, Tooltip } from "antd";
import DateTable from "../../../../controls/DateTable";
import ApiInventarioProductos from "../../../../../js/api/global/InventarioProductos";
import ApiInventarios from "../../../../../js/api/global/Inventarios";
import fileDownload from "js-file-download";
import { createPriceColumn } from "../../../../helpers/tableHelpers";
import InventoriesProductEdit from "./InventoriesProductEdit";
import { Widgets } from "../../../../controls/Widgets";
import { formatCurrencyCLP } from "../../../../utils/formatPrices";
import { openNotification } from "../../../../controls/Notifications";
import { DownOutlined } from "@ant-design/icons";
import ApiInventarioProductoLog from "../../../../../js/api/global/InventarioProductoLog";
import { HistoryModal } from "./HistoryModal";

const InventoriesView = ({ inventorySelected }) => {
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [productSelected, setProductSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inventario, setInventario] = useState([]);
  const [isProductUpdated, setIsProductUpdated] = useState(false);
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);
  const [productHistory, setProductHistory] = useState([]);

  let diferencia, totalFisico, totalTeorico;

  if (inventario?.[0]?.resultadoPrecios) {
    ({ diferencia, totalFisico, totalTeorico } =
      inventario[0].resultadoPrecios);
  }

  const categoriasUnicas = {};
  inventario.forEach((producto) => {
    categoriasUnicas[producto.categoria] = true;
  });
  const categoriesFilter = Object.keys(categoriasUnicas).map((categoria) => {
    return { text: categoria, value: categoria };
  });

  const renderEstadoProducto = (inventario) => {
    let color = "";
    switch (inventario.estado) {
      case "OK":
        color = "green";
        break;
      case "DIFERENCIA BAJA":
        color = "blue";
        break;
      case "DIFERENCIA MEDIA - REVISAR":
        color = "orange";
        break;
      case "DIFERENCIA ALTA - REVISAR":
        color = "red";
        break;
      default:
        color = "default"; // Color predeterminado
        break;
    }
    return <Tag color={color}>{inventario.estado}</Tag>;
  };

  const editProductoSucursal = (producto) => {
    const { precioUnitario, cantidad, cantidadTeorica } = producto || {};
    if (precioUnitario == null || cantidad == null || cantidadTeorica == null) {
      openNotification(
        "e",
        "No se puede editar",
        " El producto no se ha ingresado al inventario"
      );
      setIsEditVisible(false);
      setProductSelected(null);
    } else {
      setProductSelected(producto);
      setIsEditVisible(true);
    }
  };

  const viewHistory = async (producto) => {
    try {
      const response = await ApiInventarioProductoLog.GetInventarioProductoLog(
        producto?.id
      );
      setProductHistory(response.dataList);
      setIsHistoryVisible(true);
      setProductSelected(producto);
    } catch (error) {
      setProductSelected(null);
      console.error("Error al obtener el historial del producto:", error);
      openNotification(
        "error",
        "Error",
        "No se pudo obtener el historial del producto."
      );
    }
  };

  const handleMenuClick = (key, producto) => {
    switch (key) {
      case "edit":
        editProductoSucursal(producto);
        break;
      case "history":
        viewHistory(producto);
        break;
      default:
        break;
    }
  };

  const getMenuItems = (producto) => [
    {
      label: "Editar",
      key: "edit",
      onClick: () => handleMenuClick("edit", producto),
    },
    {
      label: "Ver historial",
      key: "history",
      onClick: () => handleMenuClick("history", producto),
    },
  ];

  const columns = [
    {
      title: "Código de barra",
      dataIndex: "codigoBarra",
      key: "codigoBarra",
      search: true,
    },
    {
      title: "Categoria",
      dataIndex: "categoria",
      key: "categoria",
      onFilter: (value, record) => record.categoria.indexOf(value) === 0,
      filters: categoriesFilter,
    },
    {
      title: "Producto",
      dataIndex: "productoSucursal",
      key: "productoSucursal",
      search: true,
    },
    {
      title: "Fecha",
      dataIndex: "fechaFormateada",
      key: "fechaFormateada",
      search: true,
    },
    {
      title: "Código maestra",
      dataIndex: "codigoMaestra",
      key: "codigoMaestra",
      search: true,
    },
    {
      title: "Cantidad Teórica",
      dataIndex: "cantidadTeorica",
      key: "cantidadTeorica",
      search: true,
    },
    {
      title: "Cantidad Física",
      dataIndex: "cantidad",
      key: "cantidad",
      search: true,
    },
    {
      title: "Diferencia",
      dataIndex: "diferencia",
      key: "diferencia",
      search: true,
    },
    {
      title: "Porcentaje Diferencia",
      dataIndex: "porcentajeDiferencia",
      key: "porcentajeDiferencia",
      search: true,
    },
    createPriceColumn("Precio Unitario", "precioUnitario", "precioUnitario"),
    createPriceColumn("Total Físico", "precioTotalFisico", "totalFisico"),
    createPriceColumn("Total Teórico", "precioTotalTeorico", "totalTeorico"),
    createPriceColumn(
      "Diferencia de inventario",
      "diferenciaPrecioProducto",
      "diferenciaPrecio"
    ),
    {
      title: "Estado Producto",
      render: renderEstadoProducto,
      filters: [
        {
          text: "DIFERENCIA ALTA",
          value: "DIFERENCIA ALTA - REVISAR",
        },
        {
          text: "DIFERENCIA MEDIA",
          value: "DIFERENCIA MEDIA - REVISAR",
        },
        {
          text: "DIFERENCIA BAJA",
          value: "DIFERENCIA BAJA",
        },
        {
          text: "DIFERENCIA NEGATIVA - REVISAR",
          value: "DIFERENCIA NEGATIVA - REVISAR",
        },
        {
          text: "OK",
          value: "OK",
        },
        {
          text: "N/A",
          value: "N/A",
        },
      ],
      onFilter: (value, record) => record.estado === value,
    },
    {
      title: "Acción",
      dataIndex: "",
      key: "x",
      render: (inventorie) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Dropdown
            menu={{ items: getMenuItems(inventorie) }}
            trigger={["click"]}
          >
            <Tooltip title="Opciones">
              <Button
                type="text"
                icon={<DownOutlined />}
                aria-label="Más opciones"
              />
            </Tooltip>
          </Dropdown>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (true) {
      setLoading(true);
      ApiInventarioProductos.GetInventarioProductoSelectedById(
        inventorySelected.id
      )
        .then((resp) => {
          setLoading(false);
          setInventario([...resp.data]);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error al obtener datos del inventario:", error);
          setInventario([]);
        });
    }
  }, [inventorySelected, isProductUpdated]);

  const downloadInventories = () => {
    // pasar el row inventario desde el componente anterior
    ApiInventarios.GetInventarioToDownload(inventorySelected.id).then(
      (resp) => {
        const { empresa, sucursal, correlativo, fechaFormateada } =
          inventorySelected;
        const fileName = `Inventario ${empresa} (${sucursal}) N${correlativo} - ${fechaFormateada}.xlsx`;
        fileDownload(resp, fileName);
      }
    );
  };

  const widgetsData = [
    {
      title: "Total físico",
      value: loading ? undefined : formatCurrencyCLP(totalFisico || 0),
    },
    {
      title: "Total teórico",
      value: loading ? undefined : formatCurrencyCLP(totalTeorico || 0),
    },
    {
      title: "Diferencia de inventario",
      value: loading ? undefined : formatCurrencyCLP(diferencia || 0),
    },
  ];

  return (
    <>
      <Widgets widgets={widgetsData} />
      <Row justify="end" align="middle" style={{ marginBottom: "10px" }}>
        <Col>
          <Button
            type="primary"
            onClick={() => downloadInventories(inventario)}
          >
            Descargar
          </Button>
        </Col>
      </Row>
      <br />
      <DateTable
        data={inventario}
        columns={columns}
        keyValue="id"
        loading={loading}
      />
      {productSelected && (
        <InventoriesProductEdit
          isVisible={isEditVisible}
          setIsVisible={setIsEditVisible}
          productSelected={productSelected}
          setProductSelected={setProductSelected}
          isProductUpdated={isProductUpdated}
          setIsProductUpdated={setIsProductUpdated}
        />
      )}
      <HistoryModal
        visible={isHistoryVisible}
        onCancel={() => setIsHistoryVisible(false)}
        productHistory={productHistory}
        loading={loading}
        productSelected={productSelected}
      />
    </>
  );
};

export default InventoriesView;
